import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { ReviewChartContainer } from './styles';

interface ChartProps {
  data: Array<number>;
  categories: Array<number | string>;
  title: string;
  type: 'quantidade' | 'valor';
}

export function ReviewChart({ data, categories, title, type }: ChartProps) {
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      foreColor: '#6b6b6b6b',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: '6px',
          fontWeight: 600,
        },
      },
    },
    grid: {
      show: true,
    },
    yaxis: {
      show: true,
      labels: {
        formatter: (val) => {
          return new Intl.NumberFormat('pt-Br', {
            style: 'currency',
            currency: 'BRL',
          })
            .format(val)
            .replace(/,..$/, '');
        },
        style: {
          fontSize: '6px',
          fontWeight: 600,
        },
      },
    },
    fill: {
      colors: ['#b7cb21'],
    },
  };
  const optionsQuantity: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      foreColor: '#6b6b6b6b',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: '6px',
          fontWeight: 600,
        },
      },
    },
    grid: {
      show: true,
    },
    yaxis: {
      show: true,
      labels: {
        style: {
          fontSize: '6px',
          fontWeight: 600,
        },
      },
    },
    fill: {
      colors: ['#b7cb21'],
    },
  };

  const series = [
    {
      data,
    },
  ];
  return (
    <ReviewChartContainer>
      <h1>{title}</h1>
      {/* @ts-ignore*/}
      <ReactApexChart
        options={type === 'valor' ? options : optionsQuantity}
        series={series}
        type="bar"
        height={window.innerWidth > 2000 ? 600 : '100%'}
        width="100%"
      />
    </ReviewChartContainer>
  );
}
